<!-- 状态列表 -->
<template>
	<div style="height: 100%">
		<!-- 中 -->
		<div class="chooseBox spaceBetween">
			<div class="selectBox">
				<div style="display: flex;align-items: center">
					<p style="margin-right: 20px">{{$t('label_524')}}</p>
					<el-radio v-model="radio" label="1" @change="selLables">{{$t('label_542')}}</el-radio>
					<el-radio v-model="radio" label="2" @change="selLable">{{$t('label_537')}}</el-radio>
					<div v-show="timeChange==1">
						<!-- <el-date-picker v-model="Readytime" type="monthrange" align="right" :clearable="false" format="yyyy-MM"
						 value-format="yyyy-MM" range-separator="{{$t('label_264')}}" start-placeholder="开始月份" end-placeholder="结束月份" style='width:355px;'>
						</el-date-picker> -->
						<el-date-picker v-model="Readytime[0]" type="month" :clearable="false" format="yyyy-MM" value-format="yyyy-MM"
						 style='width:120px;'>
						</el-date-picker>
						<span style="margin: 0 5px;">{{$t('label_264')}}</span>
						<el-date-picker v-model="Readytime[1]" type="month" :clearable="false" format="yyyy-MM" value-format="yyyy-MM"
						 style='width:120px;'>
						</el-date-picker>
					</div>
					<div v-show="timeChange==2">
						<!-- <el-date-picker v-model="value1" type="datetimerange" :clearable="false" format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:00:00"
						 range-separator="{{$t('label_264')}}" :start-placeholder="$t('label_329')" :end-placeholder="$t('label_388')" style='width:355px;'>
						</el-date-picker> -->
						<el-date-picker v-model="value1[0]" type="datetime" :clearable="false" format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:00:00"
						 style='width:180px;'>
						</el-date-picker>
						<span style="margin: 0 5px;">{{$t('label_264')}}</span>
						<el-date-picker v-model="value1[1]" type="datetime" :clearable="false" format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:00:00"
						 style='width:180px;'>
						</el-date-picker>
					</div>
				</div>
<!--        <div class="selectChoose">-->
<!--          <div class="selectTexts">-->
<!--            <p>排序</p>-->
<!--          </div>-->
<!--          <el-select v-model="sortName">-->
<!--            <el-option label="设备编号" value="code">-->
<!--            </el-option>-->
<!--          </el-select>-->
<!--        </div>-->
<!--        <div style="display: flex;align-items:center">-->
<!--          <el-radio v-model="sort" label="ASC">升序</el-radio>-->
<!--          <el-radio v-model="sort" label="DESC">降序</el-radio>-->
<!--        </div>-->
<!--        <div class="selectChoose">-->
<!--          <div class="selectText">-->
<!--            <p>设备编号</p>-->
<!--          </div>-->
<!--          <div class="select" style="width:350px">-->
<!--            <el-input v-model="deviceCode" clearable></el-input>-->
<!--          </div>-->
<!--        </div>-->
			</div>
			<div class="buttonBox">
				<div class="chooseButton sendButton" @click="search"><i class="el-icon-search"></i>{{$t('btn_2')}}</div>
			</div>

		</div>
		<div>
			<el-checkbox v-for="(item,index) in checkBoxList" :key="item.key" style="margin-left: 20px;" type="checkbox"
			 :checked="item.check" v-model="item.check">
				<div :style="{'background':item.color}" class="checkBoxs"></div>
				<li style="list-style: none;"> &nbsp; {{$t(item.text)}}</li>
			</el-checkbox>
		</div>
		<div class="spotMes2Box" style="height:calc(100% - 115px)">
<!--/*			<div class="buttonBox" style="margin-bottom: 10px;" v-if="MenuRoleList.indexOf('106')>=0">*/-->
<!--				<div>-->
<!--					<div class="chooseButton searchButton" @click="exportClick"><i class="el-icon-upload2"></i>{{$t('btn_10')}}</div>-->
<!--				</div>-->
<!--			</div>-->
			<div class="tableMin" style="height: calc(100% - 100px);">
				<el-table :empty-text="$t('label_357')" v-loading="loading" ref="singleTable" :data="selectDataEventListList" highlight-current-row
				 @current-change="handleCurrentChangeTree" border style="width: 100%;margin: 10px 0" height="100%"
				 :header-cell-style="{'background-color': '#45494f','color': '#ffffff',}">
					<el-table-column header-align="center" align="center" :label="$t('label_369') + '.'" type="index" :index="getIndex" width="50">
					</el-table-column>
					<el-table-column prop="name" :label="$t('label_593')" align="left">
						<template slot-scope="scope">
							<span style="font-size: 16px;"> {{scope.row.code+scope.row.name}} </span><br />
							{{scope.row.code+'<'+scope.row.companyNumber+'>'}}<br />
							{{scope.row.superior}}
						</template>
					</el-table-column>
					<el-table-column prop="type" :label="$t('label_171')" align="left" width="120">
						<!--  <template slot-scope="scope" style="text-align: center;">
								      <div style="background: #3fb393;" class="checkBoxs"></div>
								     <li style="list-style: none;float: left;margin-left: 4px;" v-model="getLastValue"> {{val.lastValue}}
								      </li>
								    </template> -->
						<template slot-scope="scope">
							<div :style="{background:$store.getters.getColor['3'].color}" class="checkBoxs" v-if="scope.row.lastValue == 3"></div>
							<div :style="{background:$store.getters.getColor['2'].color}" class="checkBoxs" v-if="scope.row.lastValue == 2"></div>
							<div :style="{background:$store.getters.getColor['1'].color}" class="checkBoxs" v-if="scope.row.lastValue == 1"></div>
							<div :style="{background:$store.getters.getColor['0'].color}" class="checkBoxs" v-if="scope.row.lastValue == 0"></div>
							<div :style="{background:$store.getters.getColor['4'].color}" class="checkBoxs" v-if="scope.row.lastValue == 4"></div>
							<span style="list-style: none;float: left;margin-left: 4px;" v-if="scope.row.lastValue == 1">{{$t($store.getters.getColor['1'].description)}}</span>
							<span style="list-style: none;float: left;margin-left: 4px;" v-if="scope.row.lastValue == 2">{{$t($store.getters.getColor['2'].description)}}</span>
							<span style="list-style: none;float: left;margin-left: 4px;" v-if="scope.row.lastValue == 3">{{$t($store.getters.getColor['3'].description)}}</span>
							<span style="list-style: none;float: left;margin-left: 4px;" v-if="scope.row.lastValue == 0">{{$t($store.getters.getColor['0'].description)}}</span>
							<span style="list-style: none;float: left;margin-left: 4px;" v-if="scope.row.lastValue == 4">{{$t($store.getters.getColor['4'].description)}}</span>
						</template>
					</el-table-column>
					<el-table-column prop="startTime" :label="$t('label_181')" align="left">
						<template slot-scope="scope">
							{{scope.row.startTime}}<br />
							{{scope.row.endTime==null?$t('持续中'):scope.row.endTime}}<br />
							{{parseFloat(scope.row.duration/60).toFixed(0)+'(' + $t('label_647') + ')'}}
							<!-- {{tem}} -->
							<!-- {{scope.row.duration/60000+'(分)'}} -->
						</template>
					</el-table-column>
					<el-table-column prop="dictContentKey" :label="$t('label_185')" align="left" width="180">
						<template slot-scope="scope">
							<el-select v-model="scope.row.dictContentKey" placeholder="" @click.stop.native="stopTimer">
								<el-option v-for="item in options" :key="item.key" :label="item.val" :value="item.key">
								</el-option>
							</el-select>
						</template>
					</el-table-column>
					<el-table-column prop="remark" :label="$t('btn_29')" align="left">
						<template slot-scope="scope">
							<el-input v-model="scope.row.remark" clearable style="width: 170px;margin-left: 6px;" @click.stop.native="stopTimer">
							</el-input>
							<el-button type="primary" style="margin-left: 10px;" @click="save(scope.row)" v-if="MenuRoleList.indexOf('105')>=0">{{$t('btn_13')}}</el-button>
						</template>
					</el-table-column>
				</el-table>
				<div style="position: absolute;bottom: 0px;right: 0%">
					<Page class="item" ref="pageModel" :total="pageCount" :display="pageSize" :pagegroup="3" :currentspage="1"
					 @parentMethod="searchPage"></Page>
				</div>
			</div>
		</div>
		<exportMes :exportTitle="exportTitle" :exportData="tableDataTreeTimeExport" :exportList="exportList" ref="exportBox"></exportMes>
	</div>
</template>

<script>
	import file from "@/assets/js/file/file.js";
	import Page from "@/components/common/pageNew2";
	import popMesBox from "@/components/list/popover/pop";
	import utils from '@/utils/utils';
	import exportMes from "@/components/list/export/export";
	import signal from "@/assets/js/signal/signal.js";
	import equipmentMonitoringService from "@/assets/js/signal/equipmentMonitoringService.js";
	import $ from 'jquery'
	export default {
		name: "deviceParam",
		components: {
			utils,
			file,
			Page,
			popMesBox,
			exportMes,
		},
		props: {
			showButton: {
				type: Boolean,
				default: ''
			},
			needSort: {
				type: Boolean,
				default: true
			},
		},
		data() {
			return {
				loading: false,
				weekendMesOptions: [this.$t('label_716'), this.$t('label_719'), this.$t('label_721'), this.$t('label_723'), this.$t('label_725'), this.$t('label_728'), this.$t('label_730')],
				monthDOptions: [],
				monthOptions: [this.$t('label_245'), this.$t('label_242'), this.$t('label_238')],
				tableDataTreeTime: [],
				activeNameTree: 'second',
				checkBoxList: [{
						text: this.$t('label_841'),
						color: this.$store.getters.getColor['3'].color,
						check: true,
						key: '3',
					},
					{
						text: this.$t('label_858'),
						color: this.$store.getters.getColor['2'].color,
						check: true,
						key: '2',
					},
					{
						text: this.$t('label_565'),
						color: this.$store.getters.getColor['1'].color,
						check: true,
						key: '1',
					},
					{
						text: this.$t('label_843'),
						color: this.$store.getters.getColor['0'].color,
						check: true,
						key: '0',
					},
				],
				remarks: '',
				// getLastValue:'',
				radio: '1',
				item: '',
				input: this.$t('label_880'),
				beginTime: '',
				endTime: '',
				dyTime: '',
				timeChange: '1', // 用来判断日期格式
				newList: [], // 月份传递的list
				ydyTime: '', // 月当前时间
				typeNext: true, // 是否包含当前时间
				Readytime: [], // 时间月
				selectSignalColorList: [],
				selectSignalList: [],
				selectEfficencyList: [],
				selectEquipmentList: [],
				selectDataEventListList: [],
				date_value: '',
				date_values: '',
				date_valuess: '',
				date_valuessss: '',
				data_list_new: '',
				checked: true,
				isSave: false,
				isSelected: [],
				options: [{
					value: '选项1',
					label: '运转',

				}, {
					value: '选项2',
					label: '停止',

				}, {
					value: '选项3',
					label: '异常停止',

				}, {
					value: '选项4',
					label: '信号未定义',

				}],
				value: '',
				value1: [], //日时间
				value2: [],
				tableParamData: [{}],
				tableDataTreeTimeExport: [],
				exportTitle: this.$t('label_515'),
				exportList: [{
						column: 'name',
						title: this.$t('label_593'),
						headerAlign: 'center',
						align: 'center',
						width: '200px'
					}, {
						column: 'code',
						title: this.$t('label_194'),
						headerAlign: 'center',
						align: 'center',
						width: '200px'
					},
					{
						column: 'companyNumber',
						title: this.$t('label_684'),
						headerAlign: 'center',
						align: 'center',
						width: '200px'
					}, {
						column: 'superior',
						title: this.$t('label_161'),
						headerAlign: 'center',
						align: 'center',
						width: '200px'
					}, {
						column: 'lastValue',
						title: this.$t('label_171'),
						headerAlign: 'center',
						align: 'center',
						width: '200px'
					}, {
						column: 'startTime',
						title: this.$t('label_580'),
						headerAlign: 'center',
						align: 'center',
						width: '200px'
					}, {
						column: 'endTime',
						title: this.$t('label_585'),
						headerAlign: 'center',
						align: 'center',
						width: '200px'
					}, {
						column: 'duration',
						title: this.$t('label_682') + '(' + this.$t('label_649') + ')',
						headerAlign: 'center',
						align: 'center',
						width: '200px'
					}, {
						column: 'dictContentKey',
						title: this.$t('label_185'),
						headerAlign: 'center',
						align: 'center',
						width: '200px'
					}, {
						column: 'remark',
						title: this.$t('btn_29'),
						headerAlign: 'center',
						align: 'center',
						width: '200px'
					},

				],

				pageNum: 1,
				pageSize: 50,
				MenuRoleList: [],
				tableParamDataEdit: {
					decimals: '',
					defaultValue: "",
					length: '',
					lineLimit: '',
					name: "",
					remark: "",
					required: false,
					sort: '',
					type: '4',
					options: [],
					unit: ""
				},
				checkMesList: [{
					value: ''
				}],
				pageCount: 0,
				deviceParamTitle: this.$t('btn_14'),
				dialogDeviceParam: false,
				unitList: [],
				searchData: {
					beginTime: "",
					endTime: "",
					type: 2,
					id: 0,
					valueList: []
				},
				workTime: {},
        // deviceCode: '',
        sortName: 'code',
        sort: 'ASC'
			}
		},
		methods: {
			//初始化时间
			initDate: function() {
				let date = new Date();
				let seperator = "-";
				let year = date.getFullYear();
				let month = date.getMonth() + 1;
				let day = date.getDate();
				let currentMonth = year + seperator + this.zero(month);
				let currentDay = year + seperator + this.zero(month) + seperator + this.zero(day) + ' 00:00';
				this.Readytime = [currentMonth, currentMonth];
			},
			//补0
			zero: function(i) {
				return i > 9 ? i : '0' + i;
			},
			// 获取时间
			getTime() {
				file.selectTimee().then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.value1.push(data.data.beginTime, data.data.endTime)
					}
				}).catch((response) => {
					console.log(response)
				})
			},
			//获取时间的默认值
			getDate() {
				let start = this.Fungetdate(0) // 7天前
				let end = this.Fungetdate(0) // 当前时间
				this.dateValue.push(start, end)
				this.Readytime = this.dateValue
				this.dyTime = this.dateValue //  当前时间
			},
			stopTimer() {
				utils.clearTime();
			},
			changeSelectMonth() {
				this.tableDataTreeEdit.monthD = '';
				for (const k in this.monthOptions) {
					if (this.tableDataTreeEdit.month === this.monthOptions[k]) {
						this.monthDOptions = this.monthOptionsObj[this.tableDataTreeEdit.month]
					}
				}
			},
			// 点击单选框 月  1
			selLables(val) {
				this.timeChange = val
				// this.initDate();
			},
			// 点击单选框  日 2
			selLable(val) {
				this.timeChange = val
				// this.value1 = [this.workTime.beginTime.substring(0,13)+':00:00',this.workTime.endTime.substring(0,13)+':00:00'];
			},
			save(data) {
				equipmentMonitoringService.update(data).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.$message({
							message: this.$t('msg_21'),
							type: 'success'
						});
						let param = {
							pageNum: this.pageNum,
							pageSize: this.pageSize,
						}
						this.searchPage(param)
						$('.el-table__body-wrapper').animate({
							scrollTop: 0
						}, 700);
						//this.$refs.singleTable.bodyWrapper.scrollTop = 0

					}
				}).catch((response) => {
					console.log(response)
				})
			},

			statusType() {
				equipmentMonitoringService.statusType().then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.options = data.data
					}
				}).catch((response) => {
					console.log(response)
				})
			},


			handleCurrentChangeTree(info) {
				this.tableDataTreeInfo = info;
			},
			exportClick() {
				// this.$refs.exportBox.setExportExcel();
				window.location.href = this.$store.getters.getPostUrl + 'mes/equipmentMonitoringService/excel?' + utils.urlSplit(
					this.searchData);
			},

			// selectDataEventExcel(param) {
			// 	equipmentMonitoringService.selectDataEventExcel(param).then((response) => {
			// 		const data = response.data;
			// 		if (data.code == "1") {
			// 			this.tableDataTreeTimeExport = data.data
			// 		}
			// 	}).catch((response) => {
			// 		console.log(response)
			// 	})
			// },
			getIndex(index) {
				return (this.pageNum - 1) * this.pageSize + index + 1
			},
			updatetime(num) {
				let sdd = new Date(num);
				let yyyy = sdd.getFullYear();
				let MM = sdd.getMonth() + 1 < 10 ? '0' + (sdd.getMonth() + 1) : sdd.getMonth() + 1
				let dd = sdd.getDate() < 10 ? '0' + sdd.getDate() : sdd.getDate()
				let HH = (sdd.getHours() + 1) < 10 ? '0' + (sdd.getHours() + 1) : (sdd.getHours() + 1)
				// let mm = sdd.getMinutes() < 10 ? '0' + sdd.getMinutes() : sdd.getMinutes()
				// let ss = sdd.getSeconds() < 10 ? '0' + sdd.getSeconds() : sdd.getSeconds()
				return yyyy + "-" + MM + '-' + dd + ' ' + HH + ':' + '00' + ':00'
			},
			newMes(data, workTime, code) {
				this.workTime = workTime;
				this.searchData.id = data.id;
				this.searchData.type = data.type;
				this.value1 = [this.workTime.beginTime.substring(0, 13) + ':00:00', this.updatetime(this.workTime.endTime)];
				// this.deviceCode = code;
				this.search();
			},
			searchPage(param) {
				$('.el-table__body-wrapper').animate({
					scrollTop: 0
				}, 700);
				this.searchData.valueList = []
				for (let i = 0; i < this.checkBoxList.length; i++) {
					if (this.checkBoxList[i].check == true) {
						this.searchData.valueList.push(this.checkBoxList[i].key);
					}
				}
				if (this.searchData.valueList.length == 0) {
					this.$message({
						message: this.$t('msg_53'),
						type: 'error'
					});
					return
				}
				this.loading = true;
				let dataParam = this.searchData;
				let newParam = Object.assign(param, dataParam);
        this.$set(newParam, 'sortName', this.sortName);
        this.$set(newParam, 'sort', this.sort);
				// this.$set(newParam, 'code', this.deviceCode);
				this.pageNum = newParam.pageNum;
				this.pageSize = newParam.pageSize;
				this.$refs['pageModel'].setCurrent(this.pageNum);
				var $this = this;
				utils.clearTime();
				this.selectDataEventList(newParam);
				// this.selectDataEventExcel(newParam);
				//定时查询数据
				if (this.timeChange == 2) {
					utils.timing(function() {
						$this.selectDataEventList(newParam);
						// $this.selectDataEventExcel(newParam);
					}, 10000)
				}
			},
			selectDataEventList(param) {
				equipmentMonitoringService.selectDataEventList(param).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.selectDataEventListList = data.data.list;
						console.log(this.selectDataEventListList)
						this.pageNum = data.data.pageNum;
						this.pageCount = data.data.total;
						this.pageSize = data.data.pageSize == 0 ? data.data.size : data.data.pageSize;
						this.$refs['pageModel'].setCurrent(this.pageNum);
						this.loading = false;
						$('.el-table__body-wrapper').animate({
							scrollTop: 0
						}, 400);
					}
				}).catch((response) => {
					console.log(response)
				})
			},

			//最後一天
			getday(val, index) {
				let nextMonthFirstDay = new Date(val.substring(0, 4), val.substring(5, 7), 1);
				let oneDay = 1000 * 60 * 60 * 24;
        let lastTime = {};
				if (index == 1) {
          lastTime = new Date(nextMonthFirstDay);
				} else {
					lastTime = new Date(nextMonthFirstDay - oneDay);
				}
				let day = lastTime.getDate();
				let month = parseInt(lastTime.getMonth() + 1);
				if (month < 10) {
					month = '0' + month
				}
				if (day < 10) {
					day = '0' + day
				}
				return lastTime.getFullYear() + '-' + month + '-' + day + ' ';
			},
			//查询列表数据
			search() {
				if (this.radio == '1') { //月
					//开始时间
					if (this.workTime.beginTimeOverDay == 0) { //0不跨天；1跨天
						this.searchData.beginTime = this.Readytime[0] + '-01 ' + this.workTime.beginTime.substring(11, 19);
					} else {
						this.searchData.beginTime = this.Readytime[0] + '-02 ' + this.workTime.beginTime.substring(11, 19);
					}
					//结束时间
					if (this.workTime.endTimeOverDay == 0) { //0不跨天；1跨天
						this.searchData.endTime = this.getday(this.Readytime[1], 0) + this.workTime.endTime.substring(11, 19);
					} else {
						this.searchData.endTime = this.getday(this.Readytime[1], 1) + this.workTime.endTime.substring(11, 19);
					}
				} else { //日
					//开始时间
					this.searchData.beginTime = this.value1[0];
					//结束时间
					this.searchData.endTime = this.value1[1];
				}
				let param = {
					pageNum: 1,
					pageSize: this.pageSize,
				}
				this.searchPage(param)
			},
			getNewDay(dateTemp) {
				let nDate = new Date(dateTemp);
				let millSeconds = Math.abs(nDate) + (24 * 60 * 60 * 1000);
				let rDate = new Date(millSeconds);
				let year = rDate.getFullYear();
				let month = rDate.getMonth() + 1;
				if (month < 10) month = "0" + month;
				let date = rDate.getDate();
				if (date < 10) date = "0" + date;
			}
		},
		created() {
			// this.getTime();
			this.initDate();
			this.statusType();
			// this.search();
			this.MenuRoleList = this.$store.getters.getMenu;
		},
		beforeDestroy() {
			utils.clearTime();
		}
	}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/list/monitoring/deviceParam.vue